<template>
	<div class="category">
		<div v-if="cleanCategory.code != 'nocats'" class="category__header">
			<div class="category__title">
				{{cleanCategory.title}} <template v-if="!!picto"><a class="category__picto" :href="picto.url" target="_blank"><img :src="picto.img"></a></template>
				<notif
					v-if="!!notif"
					:story="notif.story"
					:element="normalize(notif.element, false)"
					:value="normalize(notif.value, false)"
					:offset="0"
					:tooltip-txt="notif.tooltipTxt"
					ref="notif"
				/>
			</div>
			<div v-if="!!cleanCategory.description" class="category__description" v-html="cleanCategory.description">
			</div>
		</div>
		<div class="category__content">
			<slot name="content">Contenu de la catégorie</slot>
		</div>
	</div>
</template>
<script>
	import { normalize } from 'global/js/apps.js'
	export default {
		name: 'Category',
		components: {
			Notif: () => import('global/components/Notif'),   
		},
		props: {
			category: {
				type: Object,
				required: true,
			},
			picto: {
				type: Object,
				default: null
			},
			notif: {
				type: Object,
				default: null,
			},
		},
		data: function() {
			return {
				normalize: normalize,
			}
		},
		computed: {
			cleanCategory: function() {
				let category = this.category
				if (!category.title) {
					['wording','name'].map(key => {
						if (!!category[key]) category['title'] = category[key]
					})
				}
				return category
			}
		}
	}
</script>

<style lang="scss" scoped>
@import '../css/contexte.apps.fonts';
@import '../css/contexte.apps.colors';
.category {
	margin-bottom: 0px;
	&:last-of-type {
		margin-bottom: 0;
	}
	&__header {
		margin-bottom: 1.6rem;
	}
	&__title {
		font: 700 2.9rem/$line-height-title $serif;
		max-width: 675px;
	}
	&__picto {
		display: inline-block;
		margin-left: .2em;
		opacity: .6;
		transform: translateY(4px);
	}
	&__description {
		margin-bottom: 30px;
		max-width: 700px;
	}
}
@media screen and (min-width: 1200px)  {
	.category {
		&__title {
			font-size: 1.4em;
		}
		&__description {
			max-width: 800px;
		}
	}
}
</style>